import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Breadcrumb, BreadcrumbItem, FormGroup, Input, Label, Button
} from 'reactstrap'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import {
  getUser, updateUser, deleteUser
} from '../../../actions/adminActions'
import Loading from '../../loading'
import Form from '../../../modules/Form'
import PropTypes from 'prop-types'

class AdminUserEdit extends Component {
  componentDidMount (props) {
    this.props.getUser(this.props.match.params.email)
  }

  render () {
    if (this.props.admin.user !== null) {
      return (

        <div>
          <Row className='page-title'>
            <Col>
              <h1>Edit User</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem><Link to='/admin/users'>Users</Link></BreadcrumbItem>
                <BreadcrumbItem active>Edit {this.props.admin.user.first_name} {this.props.admin.user.last_name}</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <div className='content'>
            <Row>
              <Col lg={{ size: 6, offset: 0 }}>
                <Form id='details' submit={this.props.updateUser}>
                  <FormGroup>
                    <Label for='first_name'>First Name</Label>
                    <Input type='text' name='first_name' defaultValue={this.props.admin.user.first_name} id={'first_name'} required placeholder='First Name' />
                    <div className='invalid-feedback' />
                  </FormGroup>

                  <FormGroup>
                    <Label for='last_name'>Last Name</Label>
                    <Input type='text' name='last_name' defaultValue={this.props.admin.user.last_name} id={'last_name'} required placeholder='Last Name' />
                    <div className='invalid-feedback' />
                  </FormGroup>

                  <FormGroup>
                    <Label for='Email'>Email</Label>
                    <Input type='email' name='email' defaultValue={this.props.admin.user.email} id={'email'} required placeholder='Email' />
                    <div className='invalid-feedback' />
                  </FormGroup>

                  <FormGroup>
                    <Label for='Mobile'>Mobile including country code (e.g. +447973270928)</Label>
                    <Input type='phone' pattern='(\+|(\+[1-9])?[0-9]*)' name='mobile' id={'mobile'} defaultValue={this.props.admin.user.mobile} required placeholder='e.g. +447973470928' />
                    <div className='invalid-feedback' />
                  </FormGroup>

                  <Input type='hidden' name='access_token' value={this.props.admin.user.access_token} id='access_token' />
                </Form>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button color='primary' form='details' disabled={this.props.admin.submitting}>Update <span className='spinning' /></Button>
                {(this.props.admin.user.email === this.props.admin.auth.email) ? '' : <Button className='ml-2 btn-sec' onClick={() => { this.props.deleteUser(this.props.admin.user.email) }} disabled={this.props.admin.deleting}>Delete <span className='spinning' /></Button>}
              </Col>
            </Row>
          </div>
        </div>
      )
    } else {
      return (<Loading />)
    }
  }
}

AdminUserEdit.propTypes = {
  getUser: PropTypes.func,
  updateUser: PropTypes.func,
  deleteUser: PropTypes.func,
  match: PropTypes.object,
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUser,
      updateUser,
      deleteUser
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminUserEdit))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminUsers/AdminUserEdit.jsx